<template>
  <div>
    <header-bar ref="headerBar" v-on:updateDrow="forceUpdate"/>
    <main>
      <div class="columns" style="overflow: hidden; margin: 0px;">
        <div
          class="column is-narrow"
          v-bind:style="addStyleBackColor('width: 160px; padding: 12px 0px 10000px 12px; margin-bottom: -10000px; background-color: #061E57;')"
        >
          <aside  
            class="column is-50 is-narrow-mobile section"
            v-bind:style="addStyleBackColor('padding: 0px;background-color: #061E57;')"
          >
            <ul class="menu-list">
              <li v-for="menu in menuList" :key="menu.title">
                <template v-if="isVisibleMenu(menu)">
                  <template>
                    <router-link
                      :to="getTo(menu.href)"
                      v-bind:style="addStyleBackColor('')"
                      :class="{ 'is-active': activeNum == 0 }"
                      @click="changeActiveLink(0)"
                    >
                      <span v-if="!menu.img" class="icon" style="color: #fff; height: 45px;">
                        <i v-bind:class="[menu.icon]" style="position: relative;"></i>
                        <i
                          style="position: absolute;"
                          v-if="menu.iconOverlay"
                          v-bind:class="[menu.iconOverlay] "
                        ></i>
                      </span>
                      <span v-else class="icon" style="color: #fff; width: 70px; height: 70px;">
                        <img :src="require('@/assets/'+menu.img)">
                      </span>
                      <div style="font-size: 12px; color: #fff;">{{ menu.title }}</div>
                    </router-link>
                  </template>
                  <template v-if="menu.child">
                    <ul class="menu-list childMenu" :id="menu.id" v-show="menu.href">
                      <li v-for="child in menu.child" :key="child.title">
                        <router-link
                          :to="child.href"
                          v-bind:style="addStyleBackColor('')"
                          :class="{ 'is-active': activeNum == 0 }"
                          @click="changeActiveLink(0)"
                        >
                          <template v-if="child.icon">
                            <span class="icon" style="color: #fff; height: 45px;">
                              <i v-bind:class="[child.icon]" style="position: relative;"></i>
                              <i
                                style="position: absolute;"
                                v-if="child.iconOverlay"
                                v-bind:class="[child.iconOverlay] "
                              ></i>
                            </span>
                          </template>
                          <p style="font-size: 12px; color: #fff;">{{ child.title }}</p>
                        </router-link>
                      </li>
                    </ul>
                  </template>
                </template>
              </li>
              <!-- TODO: -->
              <li>
                <template v-if="env=='development'">
                  <router-link
                      :to="getTo([{type:'default', to:'/philips/dev/devToolHome'}])"
                      v-bind:style="addStyleBackColor('')"
                    >
                      <span class="icon" style="color: #fff; height: 45px;">
                      <i v-bind:class="['mdi mdi-crosshairs-question mdi-48px']" style="position: relative;"></i>
                    </span>
                    <div style="font-size: 12px; color: #fff;">テスト用webAPI発行</div>
                    </router-link>
                </template>
              </li>
          </ul>
          </aside>
        </div>
        <div class="column" style="background-color: white; min-height: 1000px;">
          <div>
            <router-view @update-user-info="updateUserInfo()"></router-view>
          </div>
        </div>
      </div>
    </main>
    <go-to-top/>
  </div>
</template>

<script>

import Vue from "vue";
import GoToTop from "@/components/mock/base/pageTop";
Vue.component("go-to-top", GoToTop);
import menujs from "@/components/mock/philips/menu.js";

export default {
  name: "philipsIndex",
  data() {
    var env = this.$store.state.env;
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleType = userInfo.roleId;
    var menuList = menujs.menu;
    return {
      activeNum: 0,
      menuList :menuList,
      roleType,
      env,
    };
  },
  methods: {
    getTo(href){
      var hrefInfo = href.find(item => { return (item.type == this.roleType)});
      if(!hrefInfo){
        hrefInfo = href.find(item => { return (item.type == "default")});
      }
      return hrefInfo.to;
    },
    addStyleBackColor(style) {
      if (this.env == "qa") {
        // 検証環境
        if (style) {
          return style + "background-color: rgb(240, 105, 217)";
        } else {
          return {
            "background-color": "rgb(240, 105, 217)"
          };
        }
      } else if (this.env == "development") {
        // ローカル、結合環境
        if (style) {
          return style + "background-color: rgb(240, 105, 217);";
        } else {
          return {
            "background-color": "rgb(240, 105, 217)"
          };
        }
      }

      if (style) {
        return style + "background-color: #00629F;";
      } else {
        return {
          "background-color": "#00629F"
        };
      }
    },
    changeActiveLink(val) {
      activeNum = val;
    },
    isVisibleMenu(menu) {
      var roleList = menu.roleList;
      return roleList.includes(this.roleType);
    },
    changeDisplay(id) {
      var childMenuElements = document.getElementsByClassName("childMenu");
      for(var element of childMenuElements){
        if(element.id==id){
          if(element.style.display == "none"){
            element.style ="display:block;";
          } else {
            element.style ="display:none;";
          }
        } else {
            element.style ="display:none;";
        }

      }
    },
    forceUpdate(){
      this.$emit("forceUpdate");
    },
    updateUserInfo() {
      this.$refs.headerBar.redraw()
    }
  },
};
</script>
<style lang="scss" scoped>
.menu-list > li {
  margin-top:10px;
}
</style>




// WEBPACK FOOTER //
// src/components/mock/philips/index.vue